<template>
  <el-card class='results-card' :body-style='{padding:0}'>
    <div slot="header" class="clearfix">
      <span>Breakdown of test results</span>
    </div>
    <div  style='padding: 10px'>
      <results-plot :data='$store.state.results.stats'></results-plot>
    </div>
  </el-card>
</template>

<script>
  import ResultsPlot from './results-plot'

  export default {
    name: 'results-card',
    components: {ResultsPlot}
  }
</script>

<style>
  .board-header {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .results-card {
    width: 400px;
  }
</style>



// WEBPACK FOOTER //
// results-card.vue?7e0a5bf9